<template>
  <a-drawer width="50%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-row :gutter="12">
        <a-col :span="12">
          <a-form-model-item label="本次跟进结果" prop="resultType" >
            <a-select v-model="form.resultType" placeholder="请选择" >
              <a-select-option :value="1">暂无意向</a-select-option>
              <a-select-option :value="2">未联系上</a-select-option>
              <a-select-option :value="3">有意向</a-select-option>
              <a-select-option :value="4">无效信息</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="跟进方式" prop="modeType" >
            <a-select v-model="form.modeType" placeholder="请选择" >
              <a-select-option :value="1">电话</a-select-option>
              <a-select-option :value="2">微信</a-select-option>
              <a-select-option :value="3">在线</a-select-option>
              <a-select-option :value="4">来访</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="微信添加结果" prop="addWxResult" >
            <a-select v-model="form.addWxResult" placeholder="请选择" >
              <a-select-option :value="1">已加微信</a-select-option>
              <a-select-option :value="2">添加未通过</a-select-option>
              <a-select-option :value="3">搜不到微信</a-select-option>
              <a-select-option :value="4">未加微信</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="下次跟进时间" prop="nextFollowTime" >
            <a-date-picker
              style="width: 100%"
              v-model="form.nextFollowTime"
              format="YYYY-MM-DD HH:mm:ss"
              valueFormat="YYYY-MM-DD HH:mm:ss"
              show-time
              allow-clear/>
          </a-form-model-item>
          <a-form-model-item label="跟进人" prop="modifierName" >
            <a-input v-model="form.modifierName" placeholder="请输入" disabled />
          </a-form-model-item>
          <a-form-model-item label="备注" prop="remark" >
            <a-textarea :row="4" v-model="form.remark" placeholder="请输入" />
          </a-form-model-item>
        </a-col>
<!--        <a-col :span="10">-->
<!--          <a-timeline>-->
<!--            <a-timeline-item v-for="(follow,index) in followList" :key="index" color="green">-->
<!--              <p>{{ follow.createTime }}  <font size="2px">{{ follow.modifierName }}</font></p>-->
<!--              <p>跟进结果:  {{ follow.resultType == 1 ? '暂无意向' : follow.resultType == 2 ? '未联系上' : follow.resultType == 3 ? '有意向' : '无效信息' }}</p>-->
<!--              <p>跟进方式:  {{ follow.resultType == 1 ? '电话' : follow.resultType == 2 ? '微信' : follow.resultType == 3 ? '在线' : '来访' }}</p>-->
<!--              <p>微信添加结果:  {{ follow.resultType == 1 ? '已加微信' : follow.resultType == 2 ? '添加未通过' : follow.resultType == 3 ? '搜不到微信' : '未加微信' }}</p>-->
<!--              <p>下次跟进时间:  {{ follow.nextFollowTime }}</p>-->
<!--              <p>备注:  {{ follow.remark }}</p>-->
<!--            </a-timeline-item>-->
<!--          </a-timeline>-->
<!--        </a-col>-->
      </a-row>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { addFollow, queryOperator } from '@/api/biz/user'

export default {
  name: 'FollowForm',
  props: {
    sexOptions: {
      type: Array,
    },
    isNoticeOptions: {
      type: Array,
    },
    statusOptions: {
      type: Array,
    }
  },
  components: {},
  data () {
    return {
      submitLoading: false,
      open: false,
      followList: [],
      formTitle: null,
      // 表单参数
      form: {
        id: null,
        userId: null,
        resultType: null,
        modeType: null,
        addWxResult: null,
        nextFollowTime: null,
        modifierName: null,
        createTime: null,
        remark: null
      },
      // 1增加,2修改
      formType: 1,
      rules: {
        resultType: [
          { required: true, message: '本次跟进结果不能为空', trigger: 'blur' }
        ],
        modeType: [
          { required: true, message: '跟进方式不能为空', trigger: 'blur' }
        ],
        addWxResult: [
          { required: true, message: '微信添加结果不能为空', trigger: 'blur' }
        ],
        nextFollowTime: [
          { required: true, message: '下次跟进时间不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {

    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        userId: null,
        resultType: null,
        modeType: null,
        addWxResult: null,
        nextFollowTime: null,
        modifierName: null,
        createTime: null,
        remark: null
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (id) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '跟进'
      this.form.userId = id
      queryOperator().then(response => {
        this.form.modifierName = response.data.nickName
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
            addFollow(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
